export default "__VITE_ASSET__CitUuRkP__"